export default __webpack_public_path__ + "images/SpeakersPhotos/Valentín_Barrantes_Nóvalo.jpg?679835b1";